/**
 * 区域管理
 */
<template>
  <div>
    <!-- 引入任务管理 -->
    <div v-if="See">
      <div v-if="repair">
        <repairLog :vin="vin"></repairLog>
      </div>
      <div v-if="acceptance">
        <acceptanceLog :vin="vin"></acceptanceLog>
      </div>
      <div v-if="maintenance">
        <maintenanceLog :vin="vin"></maintenanceLog>
      </div>
      <div v-if="accident">
        <accidentLog :vin="vin"></accidentLog>
      </div>
      <div v-if="dispatch">
        <dispatchTask :vin="vin"></dispatchTask>
      </div>
      <div v-if="regulatory">
        <regulatoryDetails :vin="vin"></regulatoryDetails>
      </div>
      <div @click="close()">
        <img class="close" src="../../assets/img/close.png" />
      </div>
    </div>
    <div v-show="isShow" style="margin: 20px">
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>车辆监管</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 搜索筛选 -->
      <el-form :inline="true" :model="formInline" style="margin-top: 20px; heigth: 60px">
        <el-form-item>
          <el-input size="small" v-model="formInline.vin" placeholder="输入车辆编号" clearable
            @keyup.enter.native="search()"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input size="small" v-model="formInline.carNumber" placeholder="输入车牌号" clearable
            @keyup.enter.native="search()"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select size="small" v-model="formInline.carType" clearable filterable @click="onClick()"
            placeholder="请选择车辆型号">
            <el-option v-for="item in cartype" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="formInline.drivingStatus" clearable filterable placeholder="请选择驾驶状态" size="small">
            <el-option v-for="item in drivingStatusOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="formInline.faultStatus" clearable filterable placeholder="请选择故障状态" size="small">
            <el-option v-for="item in faultStatusOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-cascader v-model="region" size="small" :options="options" placeholder="请选择区域"
            :props="{ checkStrictly: true }" style="width: 100%" clearable></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
        </el-form-item>
      </el-form>
      <!--列表-->
      <el-table :data="listData" border element-loading-text="拼命加载中" style="width: 100%">
        <el-table-column align="center" label-aligin="center" prop="vin" min-width="200" label="车辆编号"></el-table-column>
        <el-table-column align="center" label-aligin="center" prop="drivingStatus" min-width="120" label="驾驶模式">
        </el-table-column>
        <el-table-column align="center" label-aligin="center" prop="onlineStatus" min-width="120" label="在线状态">
        </el-table-column>
        <el-table-column align="center" label-aligin="center" prop="faultStatus" min-width="120" label="故障状态">
        </el-table-column>
        <el-table-column align="center" label-aligin="center" prop="scheduleStatus" min-width="150" label="调度状态">
        </el-table-column>
        <el-table-column align="center" label-aligin="center" prop="carGroup" min-width="200" label="所在区域">
        </el-table-column>
        <el-table-column align="center" label-aligin="center" prop="status" min-width="150" label="运营状态"><template
            slot-scope="scope">
            <el-tag v-if="scope.row.status == '停用'" type="danger" effect="dark">{{ scope.row.status }}</el-tag>
            <el-tag v-else type="success" effect="dark">{{
              scope.row.status
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label-aligin="center" label="操作" fixed="right" width="500"
          v-if="check_auth('/web/acceptance/list') || check_auth('/web/projectMaintenanceLog/queryList') || check_auth('/web/carMonitor/detail') ||
            check_auth('/web/repair_maintenance/list') || check_auth('/web/schedule_task/get_car_task') || check_auth('/web/projectAccidentLog/list')">
          <template slot-scope="scope">
            <el-button round size="mini" @click="acceptanceLog(scope.row)"
              v-if="check_auth('/web/acceptance/list')">验车</el-button>
            <el-button round size="mini" @click="maintenanceLog(scope.row)"
              v-if="check_auth('/web/projectMaintenanceLog/queryList')">保养</el-button>
            <el-button round size="mini" @click="repairLog(scope.row)"
              v-if="check_auth('/web/repair_maintenance/list')">维保</el-button>
            <el-button round size="mini" @click="dispatchTask(scope.row)"
              v-if="check_auth('/web/schedule_task/get_car_task')">调度</el-button>
            <el-button round size="mini" @click="accidentLog(scope.row)"
              v-if="check_auth('/web/projectAccidentLog/list')">事故</el-button>
            <el-button round size="mini" type="warning" @click="regulatoryDetails(scope.row)"
              v-if="check_auth('/web/carMonitor/detail')">详细信息</el-button>
            <!-- <el-button size="mini" @click="handleOperation(scope.row)">操作</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 添加界面 -->
    <!-- <el-dialog
        title="添加"
        :visible.sync="addFormVisible"
        width="30%"
        @click="closeDialog"
        :destroy-on-close="true"
        :close-on-click-modal="false"
      >
        <div style="margin-right: 5%">
          <el-form
            label-width="120px"
            :model="addForm"
            :rules="rules"
            ref="addForm"
          >
            <el-form-item label="区域名称" prop="name">
              <el-input
                size="small"
                v-model="addForm.name"
                auto-complete="off"
                placeholder="请输入区域名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input
                size="small"
                type="textarea"
                v-model="addForm.remark"
                auto-complete="off"
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button
              size="small"
              type="primary"
              :loading="loading"
              @click="submitAddForm('addForm')"
              >保存</el-button
            >
            <el-button size="small" @click="closeDialog('addForm')"
              >取消</el-button
            >
                                        </div>
                                      </div>
      </el-dialog> -->
    <!-- 编辑界面 -->
    <!-- <el-dialog title="修改" :visible.sync="dialogVisible" width="30%">
        <div style="margin-right: 5%">
          <el-form
            label-width="120px"
            :model="editForm"
            :rules="rules"
            ref="editForm"
          >
            <el-form-item label="区域名称" prop="name">
              <el-input
                size="small"
                v-model="editForm.name"
                auto-complete="off"
                disabled
                placeholder="请输入区域名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="区域线路数" prop="line_count">
              <el-input
                size="small"
                v-model="editForm.line_count"
                auto-complete="off"
                disabled
                placeholder="请输入区域线路数"
              ></el-input>
            </el-form-item>
            <el-form-item label="区域车辆数" prop="car_count">
              <el-input
                size="small"
                v-model="editForm.car_count"
                disabled
                auto-complete="off"
                placeholder="请输入区域车辆数"
              ></el-input>
            </el-form-item>
            <el-form-item label="创建时间" prop="create_time">
              <el-date-picker
                style="width: 100%"
                v-model="editForm.create_time"
                type="datetime"
                placeholder="选择日期时间"
                default-time="12:00:00"
                value-format="yyyy-MM-dd HH:mm:ss"
                disabled
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input
                size="small"
                type="textarea"
                v-model="editForm.remark"
                auto-complete="off"
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button
              size="small"
              type="primary"
              :loading="loading"
              @click="submitForm('editForm')"
              >保存</el-button
            >
            <el-button size="small" @click="closeDialog()">取消</el-button>
                                        </div>
                                      </div>
                                    </el-dialog> -->
    </div>
  </div>
</template>

<script>
import { get_carMonitor_list, get_all_car_type, get_all_select_area } from "../../api/car_supervise/car_supervise";
import { auth } from "../../utils/util";
import Pagination from "../../components/Pagination";
import repairLog from "../projectLog/repairLog_mn.vue";
import acceptanceLog from "../projectLog/acceptanceLog_mn.vue";
import accidentLog from "../projectLog/accidentLog_mn.vue";
import maintenanceLog from "../projectLog/maintenanceLog_mn.vue";
import dispatchTask from "../dispatch/dispatch_task.vue";
import RegulatoryDetails from "../car_supervise/Regulatory_details.vue";
export default {
  // inject: ["reload"],
  data() {
    return {
      acceptance: false,
      repair: false,
      maintenance: false,
      accident: false,
      dispatch: false,
      regulatory: false,
      region: [],
      options: [],
      See: false,
      isShow: true,
      Show: false,
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      addFormVisible: false,
      dialogVisible: false,
      cartype: [],
      drivingStatusOptions: [
        {
          value: "驻车",
          label: "驻车",
        },
        {
          value: "遥控",
          label: "遥控",
        },
        // {
        //   value: "停用",
        //   label: "停用",
        // },
        // {
        //   value: "离线",
        //   label: "离线",
        // },
        // {
        //   value: "调度中",
        //   label: "调度中",
        // }, {
        //   value: "运营中",
        //   label: "运营中",
        // },
        {
          value: "自动驾驶",
          label: "自动驾驶",
        },
        {
          value: "手动驾驶",
          label: "手动驾驶",
        },
      ],
      faultStatusOptions: [
        {
          value: "故障",
          label: "故障",
        },
        {
          value: "正常",
          label: "正常",
        },
      ],

      // rules表单验证
      rules: {
        name: [{ required: true, message: "请输入区域名称", trigger: "blur" }],
        line_count: [
          { required: true, message: "请输入区域编号", trigger: "blur" },
        ],
      },
      formInline: {
        vin: "",
        carNumber: "",
        carType: "",
        groupId: "",
        drivingStatus: "",
        faultStatus: "",
        page: 1,
        limit: 10,
      },
      listData: [],
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      vin: "",
    };
  },
  // 注册组件
  components: {
    Pagination,
    repairLog,
    acceptanceLog,
    accidentLog,
    maintenanceLog,
    dispatchTask,
    RegulatoryDetails,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getData();
    this.onClick();
    this.getRegionList();
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getRegionList() {
      get_all_select_area().then((res) => {
        if (res["code"] === 0) {
          this.options = res.data;
        }
      });
    },
    check_auth(val) {
      return auth(val);
    },
    // 跳转任务管理界面
    repairLog(row) {
      this.isShow = false;
      this.repair = true;
      this.acceptance = false;
      this.accident = false;
      this.maintenance = false;
      this.dispatch = false;
      this.See = true;
      this.regulatory = false;
      this.vin = row.vin;
    },
    acceptanceLog(row) {
      this.isShow = false;
      this.acceptance = true;
      this.repair = false;
      this.accident = false;
      this.maintenance = false;
      this.dispatch = false;
      this.See = true;
      this.regulatory = false;
      this.vin = row.vin;
    },
    accidentLog(row) {
      this.isShow = false;
      this.repair = false;
      this.acceptance = false;
      this.accident = true;
      this.maintenance = false;
      this.dispatch = false;
      this.See = true;
      this.regulatory = false;
      this.vin = row.vin;
    },
    maintenanceLog(row) {
      this.isShow = false;
      this.acceptance = false;
      this.repair = false;
      this.accident = false;
      this.maintenance = true;
      this.dispatch = false;
      this.See = true;
      this.regulatory = false;
      this.vin = row.vin;
    },
    dispatchTask(row) {
      this.isShow = false;
      this.acceptance = false;
      this.repair = false;
      this.accident = false;
      this.maintenance = false;
      this.dispatch = true;
      this.See = true;
      this.regulatory = false;
      this.vin = row.vin;
    },
    regulatoryDetails(row) {
      this.isShow = false;
      this.acceptance = false;
      this.repair = false;
      this.accident = false;
      this.maintenance = false;
      this.dispatch = false;
      this.See = true;
      this.regulatory = true;
      this.vin = row.vin;
    },
    // 关闭任务管理界面
    close() {
      this.See = false;
      // this.$nextTick(() => {
      this.isShow = true;
      this.getData();
      //   });
      // this.reload();
    },

    // 获取区域列表
    getData() {
      if (this.region.length > 0) {
        for (let i = 0; i < this.region.length; i++) {
          this.formInline.groupId = this.region[this.region.length - 1];
        }
      } else {
        this.formInline.groupId = "";
      }
      get_carMonitor_list(this.formInline).then((res) => {
        if (res["code"] === 0) {
          // this.loading = false;
          this.listData = res.data.list;
          for (let i = 0; i < this.listData.length; i++) {
            if (this.listData[i].status === 0) {
              this.listData[i].status = "停用";
            } else {
              this.listData[i].status = "运营中";
            }
          }
          this.pageparm.currentPage = this.formInline.page;
          this.pageparm.pageSize = this.formInline.limit;
          this.pageparm.total = res.data["count"];
        }
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getData();
    },
    // 搜索事件
    search() {
      this.formInline.page = 1;
      this.getData();
    },
    onClick() {
      get_all_car_type().then((res) => {
        if (res["code"] === 0) {
          this.cartype = res.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.close {
  width: 1.5%;
  height: 2.5%;
  position: absolute;
  top: 6.5%;
  left: 97%;
}
</style>

 
    


// WEBPACK FOOTER //
// src/views/car_supervise/car_supervise_mn.vue